/**=========================================================
 * Module: app-localfolder.js
 * Handles page title
 =========================================================*/

 App.directive('appLocalfolder', function(){
  'use strict';

  return {
      templateUrl: '/app/views/partials/localfolder.html',
      restrict: 'E',
      replace: true
  };

});